import _assign from "object-assign";
import React, { forwardRef, useContext } from 'react';
import { Context } from './PopperContext';
var Popper = /*#__PURE__*/forwardRef(function Popper(props, ref) {
  var _useContext = useContext(Context),
      EnvironmentSpecificPopper = _useContext.Popper;

  return /*#__PURE__*/React.createElement(EnvironmentSpecificPopper, _assign({
    ref: ref
  }, props));
});
export default Popper;